import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { Button, ButtonComponent } from '../button/button.component';
@Component({
  selector: 'ui-card',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  template: `
    <div
      class="bg-white rounded-lg border border-slate-200 h-full flex flex-col"
    >
      <!-- Header -->
      @if (title()) {
      <div
        class="px-4 py-3 border-b border-slate-200 flex justify-between items-center rounded-t-lg bg-primary-25"
      >
        <h2 class="text-lg font-medium" [class]="'text-primary-600'">
          {{ title() }}
        </h2>

        @if (buttons().length > 0) {
        <div class="flex justify-end gap-2">
          @for (button of buttons(); track button) {
          <ui-button
            [icon]="button.icon"
            [variant]="button.variant"
            [size]="button.size"
            [type]="button.type"
            [disabled]="button.disabled"
            [loading]="button.loading"
            [iconOnly]="button.iconOnly"
            [hideLabel]="button.hideLabel"
            [icon]="button.icon"
            (onClick)="button.onClick()"
            >{{ button.label }}</ui-button
          >
          }
        </div>
        }
      </div>
      }

      <!-- Content -->
      <div class="p-4 flex-1">
        @if (loading()) {
        <div class="space-y-3">
          <div class="h-4 bg-slate-200 rounded animate-pulse w-3/4"></div>
          <div class="h-4 bg-slate-200 rounded animate-pulse w-1/2"></div>
          <div class="h-4 bg-slate-200 rounded animate-pulse w-5/6"></div>
        </div>
        } @else {
        <ng-content></ng-content>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  title = input<string | undefined>();
  loading = input(false);

  buttons = input<Button[]>([]);

}
